export default function VisionStatement() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">私たちのビジョン</h2>
          <div className="w-20 h-1 bg-teal-600 mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/6444ce621ec638181307653444b49301.jpg"
              alt="地域創生の拠点"
              className="w-full h-[400px] object-cover object-top rounded-lg shadow-lg"
            />
          </div>
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">地域に新しい価値を生み出す</h3>
            <p className="text-base text-gray-700 leading-relaxed mb-4">
              使われなくなった施設や眠っている地域資源を、新しい産業と雇用を生み出す拠点へと変革します。私たちは、地域が持つ本来の力を引き出し、持続可能な経済循環を創出することで、地域社会全体の活性化に貢献します。
            </p>
            <p className="text-base text-gray-700 leading-relaxed">
              単なる施設の再利用ではなく、最先端の技術と地域の特性を融合させることで、これまでにない価値を生み出し、地域の未来を切り拓きます。
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="order-2 md:order-1">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">環境と経済の両立を実現する</h3>
            <p className="text-base text-gray-700 leading-relaxed mb-4">
              脱炭素社会の実現は、私たちの重要な使命です。環境負荷を最小限に抑えながら、地域経済を活性化させる持続可能なビジネスモデルを構築します。
            </p>
            <p className="text-base text-gray-700 leading-relaxed">
              大学の研究技術を活用した循環型システムにより、環境保全と経済成長を同時に達成し、次世代に豊かな地域社会を引き継ぐことを目指します。
            </p>
          </div>
          <div className="order-1 md:order-2">
            <img
              src="https://readdy.ai/api/search-image?query=Closed-loop%20aquaculture%20system%20in%20modern%20facility%2C%20clean%20water%20circulation%20tanks%20with%20healthy%20fish%2C%20advanced%20monitoring%20equipment%2C%20researchers%20in%20lab%20coats%20checking%20water%20quality%2C%20sustainable%20food%20production%20technology%2C%20bright%20clean%20environment%20representing%20environmental%20harmony%20and%20innovation%2C%20natural%20lighting&width=800&height=600&seq=vision-statement-2&orientation=landscape"
              alt="環境と経済の両立"
              className="w-full h-[400px] object-cover object-top rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}